import { useEffect, useState } from "react";
import { axiosClient } from "../api/proxy/AxiosClient";
import Users from "./Users";

export default function SuUsers() {
  
  const user = JSON.parse(localStorage.getItem("user"));
  const [users, setUsers] = useState([]);
  //initial mode state
  const [mode, setMode] = useState("empty");
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    axiosClient
      .get("/users")
      .then((res) => setUsers(res.data))
      .catch((err) => console.error("Error fetching users", err));
  }, []);

  const createUser = async (payload) => {
    const { data: newUser } = await axiosClient.post("/users/", payload);
    setUsers([...users, newUser]);
    setSelectedUser(newUser);
    setMode("view");
  }

  const deleteUser = async (uid) => {
    await axiosClient.delete(`/users/${uid}`);
    // setUsers([...users, newUser]);
    // setSelectedUser(null);
    // setMode("view");
  }

  const restoreUser = async (uid) => {
    await axiosClient.post(`/users/${uid}/restore`);
    // setUsers([...users, newUser]);
    // setSelectedUser(newUser);
    // setMode("view");
  }

  const updateUser = async (payload) => {
    const { data: updatedUser } = await axiosClient.patch(`/users/${payload.uid}`, payload);
    setUsers(() =>
      users.map((u) => (u.uid === updatedUser.uid ? updatedUser : u))
    );
    setSelectedUser(updatedUser);
  }

  const actions = [
    {
      label: "Create User",
      active: () => mode !== "create",
      handler: () => {
        console.log("Create User clicked:");
        setMode("create");
        setSelectedUser(null);
      },
    },
    {
      label: "Delete User",
      active: () => mode !== "create",
      handler: () => {
        console.log("Delete User clicked:");
        deleteUser(selectedUser.uid);
        setMode("view");
        setSelectedUser(null);
      },
    },
  ];

  return (
    <Users
      mode={mode}
      setMode={setMode}
      typeIsActive={true}
      deletedStatusIsActive={true}
      activeStatusIsActive={true}
      initialUsers={users}
      updateUser={updateUser}
      selectedUser={selectedUser}
      setSelectedUser={setSelectedUser}
      actions={actions}
      createUser={createUser}
      restoreUser={restoreUser}
      selectOrAddMessage={'Select or Add User'}
      userIsEditable={true}
      isSuperuser={user.type === 'superuser'}
    />
  );
}
